/**
 * Info row expand/collapse functionality.
 */
jQuery(function($){
    // detect body height
    function setHeight() {
        $('.pica8-info-row__body').each(function(){
            $(this).height($('.vc_column-inner > .wpb_wrapper', this).outerHeight(true));
        });
    }
    $(window).resize(_.throttle(setHeight, 250));
    setHeight();
    // switch active states
    $('.pica8-info-row__link').click(function(e){
        e.preventDefault();
        var el = $(this).closest('.pica8-info-row');
        if (el.hasClass('collapsed')) {
            el.removeClass('collapsed');
        } else {
            el.addClass('collapsed');
        }
    });
});
jQuery(function($){
    var rowBody = $('.site-row--expand-collapse .site-row__body');
    rowBody.each(function(){
        $(this).append('<a class="site-row__toggle-link" href="#"><span class="icon-chevron-up"></span></a>');
    });
    function setHeight() {
        rowBody.each(function(){
            $(this).height($('.vc_column-inner > .wpb_wrapper', this).outerHeight(true));
        });
    }
    $(window).resize(_.throttle(setHeight, 250));
    setHeight();
    $('.site-row__toggle-link').click(function(e){
        e.preventDefault();
        var el = $(this).closest('.site-row');
        if (el.hasClass('collapsed')) {
            el.removeClass('collapsed');
        } else {
            el.addClass('collapsed');
        }
    });
});
